import { useState, useEffect, useCallback, useMemo } from "react";
import { IconButton, Box } from "@chakra-ui/react";
import { ViewIcon } from "@chakra-ui/icons";
import { useTranslation } from "react-i18next";
import Loading from "../../../Component/Loading/loading";
import apiService from "../../../Method/Report/Report_Service";
import { ThemeProvider } from "@mui/material/styles";
import TableWidget from "../../../Component/Table/TableWidget";
import theme from "../../../assets/Table/TableTheme";
import { useDataContext } from "../../../DataProvider";
import SalesDetails from "../../SALES_DETAILS";
const buildColumns = (t, onViewDetails) => [
  {
    name: "USER_NAME",
    label: t("USER_NAME"),
    options: { filter: false, sort: false },
  },
  {
    name: "BILL_TIME",
    label: t("DATE"),
    options: {
      filter: false,
      sort: false,
      customBodyRender: (value) => (value ? value.split("T")[0] : ""),
    },
  },
  { name: "CLIENT_NAME", label: t("CLIENT_NAME"), options: { filter: false, sort: false } },
  { name: "CLIENT_PHONE", label: t("CLIENT_PHONE"), options: { filter: false, sort: false } },
  { name: "CLIENT_ADDRESS", label: t("CLIENT_ADDRESS"), options: { filter: false, sort: false } },
  { name: "INVOICE_NAME", label: t("INVOICE_NAME"), options: { filter: false, sort: false } },
  { name: "BILL_ORDER", label: t("Order_No"), options: { filter: false, sort: false } },
  { name: "NOTE", label: t("NOTE_RESON"), options: { filter: false, sort: false } },
  {
    name: "TOT_QTY",
    label: t("TOT_QTY"),
    options: {
      filter: false,
      sort: false,
      customBodyRender: (value) => (value ? value.toLocaleString() : "0"),
    },
  },
  {
    name: "SERVICE_SELL",
    label: t("SERVICE_SELL"),
    options: {
      filter: false,
      sort: false,
      customBodyRender: (value) => (value ? value.toLocaleString() : "0"),
    },
  },
  {
    name: "TOT_SELL",
    label: t("TOTAL_AMO_ALL"),
    options: {
      filter: false,
      sort: false,
      customBodyRender: (value) => (value ? value.toLocaleString() : "0"),
    },
  },
  {
    name: "DISCOUNT_SELL",
    label: t("DISCOUNT_SELL"),
    options: {
      filter: false,
      sort: false,
      customBodyRender: (value) => (value ? value.toLocaleString() : "0"),
    },
  },
  {
    name: "NET_SALES",
    label: t("NET_NET_SALES"),
    options: { filter: false, sort: false },
  },
  {
    name: "",
    label: t("VIEW_DETAILS"),
    options: {
      filter: false,
      sort: false,
      customBodyRender: (_value, tableMeta) => {
        const rowIndex = tableMeta.rowIndex;
        const rowData = tableMeta?.tableData?.[rowIndex];
        const salesDetails = rowData?.SALES_DETAILS || [];

        return (
          <IconButton
            size="sm"
            className="View_Icon_Button"
            colorScheme="blue"
            aria-label="View details"
            icon={<ViewIcon />}
            onClick={() => onViewDetails(salesDetails)}
          />
        );
      },
    },
  },
];

function App() {
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const { trigger } = useDataContext();
  const [searchText, setSearchText] = useState("");
  const [selectedDetails, setSelectedDetails] = useState(null);

  const handleViewDetails = useCallback((details) => { setSelectedDetails(details || []); }, []);

  const handleBack = () => setSelectedDetails(null);

  const columns = useMemo(() => buildColumns(t, handleViewDetails), [t, handleViewDetails]);

  const [searchColumns, setSearchColumns] = useState(() =>
    columns.filter((c) => c.options?.search !== false).map((c) => c.name)
  );
  useEffect(() => {
    setSearchColumns(columns.filter((c) => c.options?.search !== false).map((c) => c.name));
  }, [columns]);

  const fetchData = useCallback(async () => {
    setLoading(true);
    const { success, data, error } = await apiService.search("GET_DELIVERY_RETURN_REPORTS", page + 1, rowsPerPage);

    if (success && data) {
      setLoading(false);
      setData(data);
      setTotalCount(data.TOTAL_COUNT || 0);
      setError("");
    } else {
      setError(error?.response?.data?.message || "Error fetching data");
      setLoading(false);
    }
  }, [page, rowsPerPage]);

  useEffect(() => {
    fetchData();
  }, [trigger, fetchData]);

  const filteredData = (data?.DETAILS || []).filter((row) => {
    const search = searchText.toLowerCase();
    return Object.values(row).some((value) =>
      value?.toString().toLowerCase().includes(search)
    );
  });

  return (
    <ThemeProvider theme={theme}>
      {error && <p className="error-message">{error}</p>}
      {isLoading && <Loading />}

      {!isLoading && (
        <Box mt={4}>
          {selectedDetails ? (<SalesDetails details={selectedDetails} handleBack={handleBack} />) : (
            <Box className="Total_Header">
              <TableWidget
                title={t("APPLICATION_SALES")}
                data={filteredData}
                onSearchChange={setSearchText}
                columns={columns}
                totalCount={totalCount}
                page={page}
                rowsPerPage={rowsPerPage}
                onPageChange={setPage}
                onRowsPerPageChange={setRowsPerPage}
                searchColumns={searchColumns}
                setSearchColumns={setSearchColumns}
              />
            </Box>
          )}
        </Box>
      )}
    </ThemeProvider>
  );
}

export default App;
